import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'

// Floating/inset app shell — the reference aesthetic is the whole shell
// (sidebar + content) sitting as one large rounded-3xl panel on a soft gray
// canvas, with generous outer margin all around, rather than the previous
// flush min-h-screen layout. The canvas (`bg-gray-100`) shows through that
// margin; the panel below carries its own `overflow-hidden rounded-3xl` so
// every child (Sidebar/Header/main) is visually clipped to the same rounded
// corners without each of them needing its own radius classes.
const Layout = () => {
  // Mobile off-canvas nav — owned here so both Header (the trigger) and
  // Sidebar (the drawer) share one source of truth. Desktop rail
  // collapse/pin state stays local to Sidebar; this is purely the
  // small-viewport open/closed toggle.
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  return (
    // Full-bleed shell — sidebar + content fill the viewport edge-to-edge.
    // `relative` anchors Sidebar's hover-expanded `lg:absolute` rail to the
    // shell (not the viewport). Sidebar's own `border-r` and Header's
    // `border-b` are what separate the regions — no floating rounded panel,
    // so it reads as the app itself, not a UI mounted inside a frame.
    <div className="relative flex h-screen overflow-hidden bg-white">
      <Sidebar mobileOpen={mobileNavOpen} onMobileClose={() => setMobileNavOpen(false)} />

      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <Header onMenuClick={() => setMobileNavOpen(true)} />

        {/* One shared content container so every page gets the SAME uniform,
            moderate padding — no per-page divergence, no oversized gutters. */}
        <main className="relative flex-1 overflow-auto bg-gray-50/60">
          <div className="mx-auto w-full max-w-[1600px] px-5 py-5 sm:px-6 sm:py-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}

export default Layout
